// extracted by mini-css-extract-plugin
module.exports = {"error":"Forbidden_error__SArPQ"};